import {PUBLIC_URL} from "@public/Global";

const svgsCache=new Map;
export const getImage=(url='')=>`${PUBLIC_URL}images/${url}`
export const getSvgPath=(name='')=>`${PUBLIC_URL}svgs/${name}.svg`
export const getSvgDom=async (name)=>{
    if(svgsCache.has(name)){
        return svgsCache.get(name);
    }
    const svg=await fetch(getSvgPath(name));
    const svgText=await svg.text();
    const parser = new DOMParser();
    const svgDom = parser.parseFromString(svgText, 'image/svg+xml').documentElement; // 解析SVG
    svgsCache.set(name,svgDom)
    return svgDom;
}
